import { GQLResponse, GQLRequest } from './GQLTypes';

export class ClientError extends Error {
  public response: GQLResponse;
  public request: GQLRequest;

  constructor (response: GQLResponse, request: GQLRequest) {
    const message = `${ClientError.extractMessage(response)}: ${JSON.stringify({
      response,
      request,
    })}`;

    super(message);

    this.response = response;
    this.request = request;

    // this is needed as Safari doesn't support .captureStackTrace
    // eslint-disable-next-line
    // @ts-ignore
    if (typeof Error.captureStackTrace === 'function') {
      // eslint-disable-next-line
      // @ts-ignore
      Error.captureStackTrace(this, ClientError);
    }
  }

  static extractMessage (response: GQLResponse) {
    if (response.errors?.length) {
      return response.errors[0].message;
    } else {
      return `GraphQL Error (Code: ${response.status})`;
    }
  }
}
